/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  //LÖSNING FÖR ATT SPÅRA KLICK TILL ÅTERFÖRSÄLJARE
    // Lyssnar på klick-events på hela sidan
    document.addEventListener('click', function(e) {
      
      // Kontrollerar om klicket skedde på (eller inuti) en återförsäljarlänk
      var link = e.target.closest('.logos__slide__link');
      
      // Om inte, gör ingenting
      if (!link) return;

      // Skickar klicket till Meta som ett custom event med namn "RetailerClick"
      // Inkluderar URL:en så vi kan se vilken återförsäljare som klickades
      if (typeof fbq !== 'undefined') {
        fbq('trackCustom', 'RetailerClick', {
          retailer_url: link.href
        });
      }

      // Skickar samma data till GA4 med eventnamnet "retailer_click"
      // retailer_url visas som parameter i GA4-rapporterna
      if (typeof gtag !== 'undefined') {
        gtag('event', 'retailer_click', {
          retailer_url: link.href
        });
      }
    });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
